var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"image-selector"}},[_vm._l((_vm.thumbnails),function(thumbnail,index){return [_c('button',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:({
              el: ("#item-image-" + index),
              container: '#item-images',
              duration: 500,
              x: true,
              y:true
            }),expression:"{\n              el: `#item-image-${index}`,\n              container: '#item-images',\n              duration: 500,\n              x: true,\n              y:true\n            }"}],key:index,staticClass:"selector",style:({ backgroundImage: ("url(" + _vm.baseUrl + (thumbnail.url) + ")") }),attrs:{"aria-label":("Scroll to image " + (index + 1))}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }